import { render, staticRenderFns } from "./MyEvaluators.vue?vue&type=template&id=4e8e0946&scoped=true"
import script from "./MyEvaluators.vue?vue&type=script&lang=js"
export * from "./MyEvaluators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e0946",
  null
  
)

export default component.exports